import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const sx = (theme) => {
    return {
        wrap: {
            display: 'flex',
            flexDirection: 'column',
            margin: '0px',
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: theme.spacing(30),
            padding: '0px 0px',
        },
        daySelect: { width: theme.spacing(10), ml: theme.spacing(2) },
        unitSelect: { width: theme.spacing(20), ml: theme.spacing(2) },
        dayGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gridGap: theme.spacing(1),
            mt: theme.spacing(1),
        },
        day: {
            display: 'flex',
            width: theme.spacing(6),
            height: theme.spacing(6),
            borderRadius: '50%',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid',
            borderColor: theme.palette.secondary.light,
            cursor: 'pointer',
        },
        daySelected: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            border: '1px solid',
            borderColor: theme.palette.primary.dark,
        },
        topMargin: {
            mt: theme.spacing(2),
        },
        marginR: {
            mr: theme.spacing(2),
        },
        occurrenceTextfield: {
            ml: theme.spacing(2),
            width: theme.spacing(25),
        },
        card: {
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(0, 0, 0, 0.1)',
            height: '100%',
        },
        radioButton: {
            paddingRight: theme.spacing(2),
            paddingY: theme.spacing(1),
            borderRadius: '4px 4px 4px 4px',
        },
        numberColumn: {
            minWidth: '20px',
        },
    };
};

export const RecurringSx = (recurring) => (theme) => ({
    subBox: {
        borderRadius: '4px',
        borderBottomWidth: 0,
        border: recurring ? '2px solid black' : 'none',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    mainCheckbox: {
        alignItems: 'center',
        borderRight: recurring ? '1px solid grey' : 'none',
        display: 'flex',
        minWidth: '20%',
        padding: '0 5px',
    },
    headerBox: {
        display: 'flex',
        borderBottom: recurring ? '1px solid grey' : 'none',
        '&.MuiInputBase-root': { borderRadius: 0 },
    },
    closeBox: {
        alignItems: 'center',
        display: 'flex',
        paddingX: theme.spacing(2),
        minWidth: '20%',
    },
    ...sx(theme),
});

export const RecurringCard = ({ children, title }) => {
    return (
        <Card sx={(theme) => sx(theme).card}>
            <CardContent>
                <Typography variant="h6" color="textSecondary" sx={(theme) => sx(theme).marginR}>
                    {title}
                </Typography>

                {children}
            </CardContent>
        </Card>
    );
};

export default sx;
